import { useFormContext } from 'react-hook-form';
import { get } from 'lodash-es';

function useShouldRender({ referenceArrayFields, referenceFields, referenceValues, referenceShow, referenceHide, requireAll, hideOnCreate, hideOnEdit }, isEdit) {
    const { watch, selectedValues } = useFormContext();
    const fieldValues = watch([...(referenceFields ?? []), ...(referenceArrayFields ?? [])]);
    const selectValues = referenceValues?.map((value) => get(selectedValues[value.field], value.property)) ?? [];
    const allValues = [...(Array.isArray(fieldValues) ? fieldValues : []), ...selectValues];

    const determineShouldRender = (val, index, config) => {
        if (!!val && config[index] === '*') return true;
        if (Array.isArray(config[index])) {
            return config[index].includes(val?.value || val);
        }
        return (val?.value || val) === config[index];
    };

    let shouldRender = true;

    if (referenceShow) {
        if (requireAll) {
            shouldRender = allValues.every((val, index) => determineShouldRender(val, index, referenceShow));
        } else {
            shouldRender = allValues.some((val, index) => determineShouldRender(val, index, referenceShow));
        }
    }
    let shouldHide = false;
    if (referenceHide) {
        if (requireAll) {
            shouldHide = allValues.every((val, index) => determineShouldRender(val, index, referenceHide));
        } else {
            shouldHide = allValues.some((val, index) => determineShouldRender(val, index, referenceHide));
        }
        shouldRender = shouldHide ? false : shouldRender;
    }

    if (hideOnCreate != null && !isEdit) {
        shouldRender = !hideOnCreate;
    }

    if (hideOnEdit != null && isEdit) {
        shouldRender = !hideOnEdit;
    }

    return shouldRender;
}

export default useShouldRender;
